import { HttpClient } from '@angular/common/http';
import { Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import { UserLoginRequest, UserLoginResponse } from './login.model';
import { BaseResponseBean } from '../core/models/base-response-bean';
import { API } from '../core/constants/api-url.constant';

@Injectable({
    providedIn: "root"
  })
export class LoginService {

  constructor(private httpClient: HttpClient) {
    
   }

  login(userLoginRequest:UserLoginRequest): Observable<any> {
    return this.httpClient.post(API.AUTH.LOGIN, userLoginRequest);
  }

  getSessionInfo(): Observable<BaseResponseBean<number, UserLoginResponse>> {
    return this.httpClient.get(API.AUTH.SESSION_INFO);
  }

  logout() {
    return this.httpClient.post(API.AUTH.LOGOUT, {});
  }

}
